import { render, staticRenderFns } from "./HomeFurnishing.vue?vue&type=template&id=53ed09ad"
import script from "./HomeFurnishing.vue?vue&type=script&lang=js"
export * from "./HomeFurnishing.vue?vue&type=script&lang=js"
import style0 from "./HomeFurnishing.vue?vue&type=style&index=0&id=53ed09ad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports